import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import BaseLayout from '../components/BaseLayout.vue'

const routes: Array<RouteRecordRaw> = [
  //personnel login routes
  {
    path: '/personnel/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  },
  {
    path: '/personnel/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/auth/admin/Login.vue')
  },
  {
    path: '/personnel/forgot-password',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "about" */ '../views/auth/admin/ForgotPassword.vue')
  },
  {
    path: '/personnel/reset-password',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "about" */ '../views/auth/admin/ResetPassword.vue')
  },
  {
    path: '/personnel/redirect/google',
    name: 'RedirectGoogle',
    component: () => import(/* webpackChunkName: "about" */ '../views/auth/admin/Redirect.vue')
  },
  // {
  //   path: '/personnel/laravel-logs-backend',
  //   name: 'BackendLogs',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/logs/Backend.vue')
  // },
  // {
  //   path: '/personnel/laravel-logs-passthru',
  //   name: 'PassthruLogs',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/logs/Passthru.vue')
  // },
  // {
  //   path: '/personnel/laravel-logs-auth',
  //   name: 'AuthLogs',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/logs/Auth.vue')
  // },
  // {
  //   path: '/personnel/laravel-logs-email',
  //   name: 'EmailLogs',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/logs/Email.vue')
  // },
  // {
  //   path: '/personnel/laravel-logs-sms',
  //   name: 'SmsLogs',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/logs/Sms.vue')
  // },
  // {
  //   path: '/personnel/laravel-logs-cron',
  //   name: 'CronLogs',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/logs/Cron.vue')
  // },
  // {
  //   path: '/personnel/laravel-logs-vendor',
  //   name: 'VendorLogs',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/logs/Vendor.vue')
  // },
  // {
  //   path: '/personnel/laravel-logs-employee',
  //   name: 'EmployeeLogs',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/logs/Employee.vue')
  // },
  //vendor login routes
  {
    path: '/:pathMatch(.*)*',
    name: 'VendorNotFound',
    component: () => import('../views/VendorNotFound.vue')
  },
  {
    path: '/register',
    name: 'VendorRegister',
    component: () => import(/* webpackChunkName: "about" */ '../views/vendor/registration/Register.vue')
  },
  {
    path: '/login',
    name: 'VendorLogin',
    component: () => import(/* webpackChunkName: "about" */ '../views/auth/vendor/Login.vue')
  },
  {
    path: '/verify',
    name: 'VendorVerify',
    component: () => import(/* webpackChunkName: "about" */ '../views/vendor/registration/Verify.vue')
  },
  {
    path: '/forgot-password',
    name: 'VendorForgotPassword',
    component: () => import(/* webpackChunkName: "about" */ '../views/auth/vendor/ForgotPassword.vue')
  },
  {
    path: '/change-password',
    name: 'VendorChangePassword',
    component: () => import(/* webpackChunkName: "about" */ '../views/auth/vendor/ChangePassword.vue')
  },
  {
    path: '/reset-password',
    name: 'VendorResetPassword',
    component: () => import(/* webpackChunkName: "about" */ '../views/auth/vendor/ResetPassword.vue')
  },
  {
    path: '/redirect/google',
    name: 'VendorRedirectGoogle',
    component: () => import(/* webpackChunkName: "about" */ '../views/auth/vendor/Redirect.vue')
  },

  {
    path: '/personnel',
    redirect: '/personnel/dashboard',
    name: 'Home',
    component: () => import('../components/personnel/BaseContainer.vue'),
    children: [
      {
        path: '/personnel/dashboard',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/dashboard/Dashboard.vue')
      },
      {
        path: '/personnel/end-user/dashboard',
        name: 'EmployeeDashboard',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/dashboard/EmployeeDashboard.vue')
      },
      // admin settings
      {
        path: '/personnel/admin-settings',
        name: 'admin-settings',
        component: () => import('../views/admin/admin_settings/AdminSettings.vue')
      },

      // super admin settings
      {
        path: '/personnel/super-admin-settings',
        name: 'super-admin-settings',
        component: () => import('../views/admin/super_admin_settings/SuperAdminSettings.vue')
      },
      {
        path: '/personnel/create/business-unit-admin',
        name: 'create-business-unit-admin',
        component: () => import('../views/admin/super_admin_settings/business_unit_admin/Form.vue')
      },
      {
        path: '/personnel/edit/business-unit-admin/:id',
        name: 'edit-business-unit-admin',
        component: () => import('../views/admin/super_admin_settings/business_unit_admin/Form.vue'),
        props: true
      },
      {
        path: '/personnel/create/super-admin',
        name: 'create-super-admin',
        component: () => import('../views/admin/super_admin_settings/super_admin/Form.vue')
      },
      {
        path: '/personnel/edit/super-admin/:id',
        name: 'edit-super-admin',
        component: () => import('../views/admin/super_admin_settings/super_admin/Form.vue'),
        props: true
      },
      // business unit admin settings
      {
        path: '/personnel/business-unit-admin-settings',
        name: 'business-unit-admin-settings',
        component: () => import('../views/admin/business_unit_admin_settings/BusinessUnitAdminSettings.vue')
      },
      {
        path: '/personnel/permissions/system-roles-and-permissions/:id',
        name: 'set-permissions-system-roles-and-permissions',
        component: () => import('../views/admin/business_unit_admin_settings/system_roles_permissions/Permission.vue'),
        props: true
      },
      // system settings
      {
        path: '/personnel/system-settings',
        name: 'system-settings',
        component: () => import('../views/admin/system_settings/SystemSettings.vue')
      },
      {
        path: '/personnel/audit-logs',
        name: 'audit-logs',
        component: () => import('../views/admin/system_settings/audit_log/AuditLog.vue')
      },
      {
        path: '/personnel/transaction-logs',
        name: 'transaction-logs',
        component: () => import('../views/admin/system_settings/transaction_log/TransactionLog.vue')
      },


      {
        path: '/personnel/employee-masterlist',
        name: 'employee-masterlist',
        component: () => import('../views/admin/employee_management/EmployeeMasterList.vue')
      },


      {
        path: '/personnel/vendor-masterlist',
        name: 'vendor-masterlist',
        component: () => import('../views/admin/vendor_management/master_list/VendorMasterList.vue')
      },
      {
        path: '/personnel/vendor-account-list',
        name: 'vendor-account-list',
        component: () => import('../views/admin/vendor_management/accounts/List.vue')
      },

      // payment management
      {
        path: '/personnel/payment-ibps',
        name: 'payment-ibps',
        component: () => import('../views/admin/payment_management/ibps/Ibps.vue')
      },

      // data
      // DATA - ibps 
      {
        path: '/personnel/data-ibps',
        name: 'data-ibps',
        component: () => import('../views/admin/data/ibps/IBPS.vue')
      },

      // DATA - treasury coal payments
      {
        path: '/personnel/data-treasury',
        name: 'data-treasury',
        component: () => import('../views/admin/data/treasury/Treasury.vue')
      },

      //Invoice Admin Entry
      {
        path: '/personnel/invoice/admin-entry',
        name: 'invoice-admin-entry',
        component: () => import('../views/admin/payment_management/invoice/AdminEntry.vue')
      },
      {
        path: '/personnel/invoice/create/admin-entry',
        name: 'create-invoice-admin-entry',
        component: () => import('../views/admin/payment_management/invoice/AdminForm.vue')
      },
      {
        path: '/personnel/invoice/edit/admin-entry/:id',
        name: 'edit-invoice-admin-entry',
        component: () => import('../views/admin/payment_management/invoice/AdminForm.vue'),
        props: true
      },

      //Invoice End User Entry
      {
        path: '/personnel/invoice/end-user-entry',
        name: 'invoice-end-user-entry',
        component: () => import('../views/admin/payment_management/invoice/EndUserEntry.vue')
      },
      {
        path: '/personnel/invoice/create/end-user-entry',
        name: 'create-invoice-end-user-entry',
        component: () => import('../views/admin/payment_management/invoice/EndUserForm.vue')
      },
      {
        path: '/personnel/invoice/edit/end-user-entry/:id',
        name: 'edit-invoice-end-user-entry',
        component: () => import('../views/admin/payment_management/invoice/EndUserForm.vue'),
        props: true
      },


      //Employee Payment Portal
      {
        path: '/personnel/invoice/employee',
        name: 'invoice-employee-entry',
        component: () => import('../views/admin/employee_payment_portal/invoice/Invoice.vue')
      },
      {
        path: '/personnel/invoice/create/employee',
        name: 'create-invoice-employee-entry',
        component: () => import('../views/admin/employee_payment_portal/invoice/Form.vue')
      },
      {
        path: '/personnel/invoice/edit/employee/:id',
        name: 'edit-invoice-employee-entry',
        component: () => import('../views/admin/employee_payment_portal/invoice/Form.vue'),
        props: true
      },

      //Sms Template
      {
        path: '/personnel/sms-template/create',
        name: 'create-sms-template',
        component: () => import('../views/admin/system_settings/sms_template/Form.vue')
      },
      {
        path: '/personnel/sms-template/edit/:id',
        name: 'edit-sms-template',
        component: () => import('../views/admin/system_settings/sms_template/Form.vue'),
        props: true
      },

      //Email Template
      {
        path: '/personnel/email-template/create',
        name: 'create-email-template',
        component: () => import('../views/admin/system_settings/email_template/Form.vue')
      },
      {
        path: '/personnel/email-template/edit/:id',
        name: 'edit-email-template',
        component: () => import('../views/admin/system_settings/email_template/Form.vue'),
        props: true
      },

      //Payment Status Mapping
      {
        path: '/personnel/payment-status-mapping/create',
        name: 'create-payment-status-mapping',
        component: () => import('../views/admin/system_settings/payment_status_mapping/Form.vue')
      },
      {
        path: '/personnel/payment-status-mapping/edit/:id',
        name: 'edit-payment-status-mapping',
        component: () => import('../views/admin/system_settings/payment_status_mapping/Form.vue'),
        props: true
      },

      {
        path: '/personnel/notifications',
        name: 'notification',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/notification/Notification.vue')
      },

      {
        path: '/personnel/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/profile/Profile.vue')
      },
    ]
  },

  {
    path: '/',
    redirect: '/dashboard',
    name: 'HomeVendor',
    component: () => import('../components/vendor/BaseContainer.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'VendorDashboard',
        component: () => import(/* webpackChunkName: "about" */ '../views/vendor/dashboard/Dashboard.vue')
      },
      {
        path: '/payment',
        name: 'VendorPayment',
        component: () => import(/* webpackChunkName: "about" */ '../views/vendor/payment/Payment.vue')
      },
      {
        path: '/notification-recipients',
        name: 'VendorNotificationRecipient',
        component: () => import(/* webpackChunkName: "about" */ '../views/vendor/notification-recipient/NotificationRecipient.vue')
      },
      {
        path: '/profile',
        name: 'VendorProfile',
        component: () => import(/* webpackChunkName: "about" */ '../views/vendor/profile/Profile.vue')
      },


      {
        path: '/submitted/invoice',
        name: 'SubmittedInvoice',
        component: () => import(/* webpackChunkName: "about" */ '../views/vendor/payment/invoice/SubmittedInvoice.vue')
      },
      {
        path: '/invoice/create',
        name: 'InvoiceCreate',
        component: () => import(/* webpackChunkName: "about" */ '../views/vendor/payment/invoice/Form.vue')
      },
      {
        path: '/invoice/edit/:id',
        name: 'InvoiceEdit',
        component: () => import(/* webpackChunkName: "about" */ '../views/vendor/payment/invoice/Form.vue'),
        props: true
      },
      {
        path: '/notifications',
        name: 'vendor-notification',
        component: () => import(/* webpackChunkName: "about" */ '../views/vendor/notification/Notification.vue')
      },
    ]
  }



]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

// router.beforeEach((to, from, next) => {
//   // if (to.name === 'RedirectGoogle' && !window.localStorage.getItem("PPORT_TOKEN")) {
//   //   next()
//   //   return
//   // }
//   if(to.name !== 'Home'){
//     if (to.name !== 'VendorNotFound' && to.name !== 'VendorLogin' && to.name !== 'VendorForgotPassword'
//     && !window.localStorage.getItem("PAYMENT_PORTAL_VENDOR_TOKEN"))
//     next({ name: 'VendorLogin' })
//     else next()
//   }

//   if(to.name !== 'HomeVendor'){
//     if ( to.name !== 'NotFound' && to.name !== 'Login' && to.name !== 'ForgotPassword'
//     && !window.localStorage.getItem("PAYMENT_PORTAL_TOKEN"))
//     next({ name: 'Login' })
//   else next()
//   }
// })

export default router
